/**
 * Formats string, with newline characters replaced with the html entity `br`
 * @param value String to format
 * @returns Formatted string
 */
export function newlineToBr(value?: string): string {
  return value == null ? '-' : `${value}`.replace(/(\r\n|\n\r|\r|\n)/g, '<br>')
}
